.root {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.badge [data-badge='textual'] span {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  max-width: 100px;
}

.breaking [data-badge='textual'] {
  background: var(--surface-decorative-lime-default);
  color: var(--text-decorative-lime);

  svg {
    fill: var(--icon-decorative-lime);
  }
}

.watchlist [data-badge='textual'] {
  background: var(--surface-decorative-cyan-default);
  color: var(--text-decorative-cyan);

  svg {
    fill: var(--icon-decorative-cyan);
  }
}
